import { render, staticRenderFns } from "./segment-stats.vue?vue&type=template&id=d0d87872&scoped=true"
import script from "./segment-stats.vue?vue&type=script&lang=js"
export * from "./segment-stats.vue?vue&type=script&lang=js"
import style0 from "./segment-stats.vue?vue&type=style&index=0&id=d0d87872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d87872",
  null
  
)

export default component.exports